import type { FC } from 'react';
import { Avatar, MatchMedia } from '@george-labs.com/design-system';

import { useGlobalColorVariants } from '@shared/core-ui-layout';

import type { ActivePAPIProductWithAvatarData } from '../types';
import { ProductImageUpload } from './ProductImageUpload';
import { useActivePAPIProduct } from '../../../ActivePAPIProductContext';

export const PersonalizationAvatar: FC = () => {
    const { alternativeImageUrl, icon, imageData, localizedName } =
        useActivePAPIProduct<ActivePAPIProductWithAvatarData>();
    const { strongColor, weakColor } = useGlobalColorVariants();

    return (
        <MatchMedia max={MatchMedia.TIER.SM}>
            {({ isMatching }) => {
                const size = isMatching ? Avatar.SIZE.SIZE_64 : Avatar.SIZE.SIZE_96;

                return (
                    <ProductImageUpload
                        dropdownToggle={
                            <Avatar
                                icon={icon}
                                imageUrl={imageData || alternativeImageUrl}
                                color={strongColor}
                                backgroundColor={weakColor}
                                variant={Avatar.VARIANT.BORDERLESS}
                                size={size}
                            />
                        }
                        trigger="productIcon"
                        productType={localizedName}
                    />
                );
            }}
        </MatchMedia>
    );
};
